/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import {
	GET_ALL_CARBON_INTENSITY_RESPONSE,
	GET_MONTHLY_AVERAGE_BY_REGION_RESPONSE,
	GET_HOURLY_AVERAGE_BY_REGION_RESPONSE
} from "./what-if-carbon-intensity.db";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class WhatIfCarbonIntensity {
	public static getAllCarbonIntensity() {
		return of(GET_ALL_CARBON_INTENSITY_RESPONSE);
	}

	public static getMonthlyAverageByRegion(options: HttpRequestOptions) {
		const { pathParams } = options;

		const region = pathParams?.["region"];

		if (!region)
			return throwError(
				() =>
					new ApplicationError(
						"No region parameter provided",
						this.constructor.name,
						this.getMonthlyAverageByRegion.name
					)
			);

		return of(GET_MONTHLY_AVERAGE_BY_REGION_RESPONSE);
	}

	public static getHourlyAverageByRegion(options: HttpRequestOptions) {
		const { pathParams } = options;

		const region = pathParams?.["region"];

		if (!region)
			return throwError(
				() =>
					new ApplicationError(
						"No region parameter provided",
						this.constructor.name,
						this.getHourlyAverageByRegion.name
					)
			);

		return of(GET_HOURLY_AVERAGE_BY_REGION_RESPONSE);
	}
}
